import request from '@/utils/request'
import * as Auth from '@/interfaces/auth'
import { AxiosPromise } from 'axios'

const path = '/token'
const FacebookApiVersion = process.env.VUE_APP_FB_JSSDK_VERSION

export function loginWithUserPhone (data: Auth.ILoginRequest): AxiosPromise<Auth.ILoginResponse> {
  return request({
    url: `${path}/login_api.php`,
    method: 'post',
    data
  })
}

export function loginWithFacebook (data: Auth.IFacebookLoginRequest): AxiosPromise<Auth.ILoginResponse> {
  return request({
    url: `${path}/fb_login_api.php`,
    method: 'post',
    data
  })
}

export function exchangeFacebookToken (data: Auth.IFacebookExchangeRequest): AxiosPromise<Auth.IExchangeResponse> {
  return request({
    url: `${path}/fb_exchange_token.php`,
    method: 'post',
    data
  })
}

export function refreshTokenWithAccount (data: Auth.IRefreshTokenRequest): AxiosPromise<Auth.ILoginResponse> {
  return request({
    url: `${path}/login_api.php`,
    method: 'post',
    data
  })
}

export function sendValidationCode (data: Auth.ISendVCodeRequest): AxiosPromise<any> {
  return request({
    url: `${path}/send_vcode_api.php`,
    method: 'post',
    data
  })
}

export function checkValidationCode (data: Auth.ICheckVCodeRequest): AxiosPromise<any> {
  return request({
    url: `${path}/validate_vcode_api.php`,
    method: 'post',
    data
  })
}

export function changePassword (data: Auth.IChangePasswordRequest): AxiosPromise<any> {
  return request({
    url: `${path}/modify_password_api.php`,
    method: 'post',
    data
  })
}

export function setPassword (data: Auth.ISetPasswordRequest): AxiosPromise<any> {
  return request({
    url: `${path}/register_api.php`,
    method: 'post',
    data
  })
}

export function getFacebookProfile (params: any): AxiosPromise<any> {
  return request({
    baseURL: `https://graph.facebook.com/${FacebookApiVersion}`,
    url: '/me',
    method: 'get',
    transformRequest: [],
    withCredentials: false,
    params
  })
}

export function deleteAccount (data: Auth.IAuthRequest): AxiosPromise<any> {
  return request({
    url: `${path}/delete_account.php`,
    method: 'post',
    data
  })
}
